import { render, staticRenderFns } from "./el-data-table.vue?vue&type=template&id=57a6ca7e&"
import script from "./el-data-table.vue?vue&type=script&lang=js&"
export * from "./el-data-table.vue?vue&type=script&lang=js&"
import style0 from "./el-data-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "el-data-table.vue"
export default component.exports